import styled, { css } from 'styled-components'

import { hexToRgb } from '@website/common/utils'

import { BUTTON_SIZE } from './consts'

export const ButtonWrapper = styled.div`
  position: fixed;
  z-index: 19;
  right: 20px;
  top: ${({ isCentered }) => (isCentered ? '50%' : 'auto')};
  bottom: ${({ isCentered }) => (isCentered ? 'auto' : '0')};
  transform: ${({ isCentered }) => (isCentered ? 'translateY(-50%)' : 'none')};
  margin-bottom: 20px;
  ${({ additionalSpace }) =>
    additionalSpace &&
    css`
      transform: translateY(-${additionalSpace}px);
    `}
`

export const floatingButtonStyles = css`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  background: ${({ theme }) =>
    theme.look === 'SHARP'
      ? theme.palette.accentWhite
      : `transparent linear-gradient(180deg, 
      ${theme.palette.accentWhite} 0%, 
      ${theme.palette.tertiaryLight} 100%) 
      0% 0% no-repeat`};
  border: ${({ theme }) =>
    `1px solid ${
      theme.look === 'SHARP'
        ? theme.palette.primaryDark
        : theme.palette.tertiaryLight
    }`};
  border-radius: ${({ theme }) =>
    theme.look === 'ROUNDED'
      ? '50%'
      : theme.look === 'CORNERED'
      ? '10px'
      : '0'};
  box-shadow: ${({ theme }) =>
    `0px 4px 8px rgba(${hexToRgb(theme.palette.tertiaryDark)}, 0.15)`};
  &:hover {
    background: ${({ theme }) =>
      theme.look === 'SHARP'
        ? theme.palette.tertiaryLight
        : theme.palette.accentWhite};
  }
`

export const Button = styled.button`
  ${floatingButtonStyles}
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? '1' : '0')};
  transition: opacity 0.2s, visibility 0.2s;
  & > div {
    svg {
      flex-shrink: 0;
      fill: ${({ theme }) => theme.palette.primaryDark};
    }
  }
`
